export const CHANGE_INDEX_FORM = 'changeIndexForm';
export const CHANGE_INDEX_CONFLICT_FORM = 'changeIndexConflictForm';

export const changeIndexModalTitles = {
  [CHANGE_INDEX_FORM]: 'Change Index #',
  [CHANGE_INDEX_CONFLICT_FORM]: 'Index Position Unavailable',
};
